<template>
	<div class="index">
		<div class="content">
			<p class="help">常见问题：什么是预加解封？ 什么是直接解封？保费是什么？</p>

			<div class="left">
				<div class="left-top">
					<dl>
						<dt><img :src="UserInfo[0].IconUrl" width="80" height="80" ></dt>
						<dd>{{UserInfo[0].Nickname}}<span>ID：{{UserInfo[0].UID}}</span></dd>
					</dl>
				</div>
				<div class="left-bottom">
					<h2>账户余额</h2>
					<p>￥{{toMoney}}</p>
					<p>
						<el-button type="primary" class="fr" size="small" >提现</el-button>
						<el-button type="warning" class="mg20 fr" size="small"  @click="showRechargeWindow">充值</el-button>
					</p>
				</div>
			</div>

			<div class="middle">
				<div class="middle-d">
					<h3>发布的订单</h3>
					<ul>
						<li><router-link :to="{ name: 'myPub', query: { state: 1 }}">{{Data[0].Pub1}}<em>未接手</em></router-link></li>
						<li><router-link :to="{ name: 'myPub', query: { state: 2 }}">{{Data[0].Pub2}}<em>进行中</em></router-link></li>
						<li><router-link :to="{ name: 'myPub', query: { state: 3 }}">{{Data[0].Pub3}}<em>等待验收</em></router-link></li>
						<li><router-link :to="{ name: 'myPub', query: { state: 4 }}">{{Data[0].Pub4}}<em>撤销中</em></router-link></li>
					</ul>
					<p><el-button type="primary" class="fr" size="small" @click="showAddOrderDialog">我要发单</el-button></p>
				</div>
				<div class="middle-d pt20">
					<h3>接手的订单</h3>
					<ul>
						<li><router-link :to="{ name: 'home'}">{{Data[0].Accept1}}<em>可接手</em></router-link></li>
						<li><router-link :to="{ name: 'myAccept', query: { state: 2 }}">{{Data[0].Accept2}}<em>进行中</em></router-link></li>
						<li><router-link :to="{ name: 'myAccept', query: { state: 3 }}">{{Data[0].Accept3}}<em>等待验收</em></router-link></li>
						<li><router-link :to="{ name: 'myAccept', query: { state: 4 }}">{{Data[0].Accept4}}<em>撤销中</em></router-link></li>
					</ul>
					<p><router-link :to="{ name: 'home'}"><el-button type="primary" class="fr" size="small">我要接单</el-button></router-link></p>
				</div>
			</div>

			<div class="right">
				<div class="middle-r">
					<h3>我发布的</h3>
					<div class="totalNum">{{PubCount}}<span>单</span></div>
					<p>撤单数<span>{{UserInfo[0].PubConsultCancel}}单</span></p>
					<p>结算率<span>{{PubSettleRate}}%</span></p>
					<p>近50单结算时间<span>{{PubSettleHour}}小时</span></p>
				</div>
				<div class="middle-r pt20">
					<h3>我接手的</h3>
					<div class="totalNum">{{AcceptCount}}<span>单</span></div>
					<p>撤单数<span>{{UserInfo[0].AcceptConsultCancel}}单</span></p>
					<p>结算率<span>{{AcceptSettleRate}}%</span></p>
				</div>
			</div>
		</div>

		<addOrder :isShow="isShow" @on-close="closeWindow" @on-success-add="successAddWindow"></addOrder>
		<recharge :isShow="isShowRechargeWindow" @on-close="closeRechargeWindow" ></recharge>
		
	</div>
</template>
<style scoped>
	.index{ background:#f5f5f5; padding-bottom:80px;}
	.index p.help{ font-size:16px; color:#444444; font-weight: normal; height:60px; line-height: 60px;}
	.index .mg20{margin:0 20px;}
	.index .pt20{margin-top:20px;}

	.left{float:left;}
	.middle{float: left; margin-left:18px;}
	.right{float:right;}
	.left-top{ background: #fff; width:365px; height:140px; }
	.left-top dl{ padding-top:28px; margin-left:20px;}
	.left-top dt{float: left;}
	.left-top dd{ font-size:18px; color:#444; float: left;  vertical-align: middle; padding-left:20px; padding-top:15px; }
	.left-top dd span{ display:block;font-size:16px; padding-top:15px;}
	.left-top img{border-radius: 80px;}

	.left-bottom{background: #fff; width:365px; height:180px; margin-top:20px; }
	.left-bottom h2{ font-size:16px; color:#666; border-bottom:solid 1px #f2f2f2; padding-bottom: 15px; margin:0 22px; padding-top:20px; }
	.left-bottom p{ font-size:30px; color:#444; padding-top:15px; margin:0 22px;}

	.middle-d{ width:500px; height:225px;background: #fff;}
	.middle-d h3,.middle-r h3{font-size:18px; color:#444; font-weight: normal; height:50px; line-height: 50px; margin:0 20px;border-bottom:solid 1px #f2f2f2;}
	.middle-d span{ float:right; font-size:16px; color:#666;}

	.middle-d ul{height:120px;}
	.middle-d li{float: left; font-size:16px; color:#666; padding:0 35px; text-align: center; padding-top:30px; }
	.middle-d li a{font-size:28px; color:#5190ff; display: block; }
	.middle-d li a:hover{ text-decoration: none;}
	.middle-d li em{font-size: 16px; color:#666; display:block; padding-top:15px;}
	.middle-d p{ margin-right:20px;}

	.middle-r{ width:380px; height:250px; background: #fff;}
	.middle-r .totalNum{ height:80px; line-height:80px; margin:0 20px; font-size:38px; color:#444; }
	.middle-r .totalNum span{font-size:20px; color:#444; padding-left:20px;}
	.middle-r p{font-size:14px; color:#666;margin:0 20px;line-height: 35px;}
	.middle-r p span{font-size:18px; color:#444; float:right; }
</style>
<script>
	import addOrder from "../components/addOrder"
	import recharge from "../components/recharge"
	export default {
		name: 'index',
		components: {addOrder:addOrder,recharge:recharge},
		methods: {
			 GetUserInfo(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var obj=JSON.parse(data);
				var userId=obj.UserID;
				self.http.ajaxGet("UserInfo?UserID="+userId,function(res){
					if(res.ReturnCode == 1){
						self.UserInfo=res.Result;
					}else{
						self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
					}	
				},function(err){
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			},
			GetData(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var obj=JSON.parse(data);
				var userId=obj.UserID;
				self.http.ajaxGet("Index?UserID="+userId,function(res){
					if(res.ReturnCode == 1){
						self.Data=res.Result;
					}else{
						self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
					}	
				},function(err){
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			},
			showAddOrderDialog(){
				this.isShow=true;
			},
			closeWindow(val){
				this.isShow=val;
			},
			successAddWindow(OrderType){
				this.Data[0].Pub1=this.Data[0].Pub1+1;
				this.closeWindow(false);
			},
			number_format(number, decimals, dec_point, thousands_sep) {
			　　number = (number + '').replace(/[^0-9+-Ee.]/g, '');
			　　var n = !isFinite(+number) ? 0 : +number,
			　　prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
			　　sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
			　　dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
			　　s = '',
			　　 toFixedFix = function(n, prec) {
			　　　　var k = Math.pow(10, prec);
			　　　　return '' + Math.ceil(n * k) / k;
			　　};

			　　s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
			　　 var re = /(-?\d+)(\d{3})/;
			　　 while(re.test(s[0])) {
			　　　　s[0] = s[0].replace(re, "$1" + sep + "$2");
			　　}

			　　if((s[1] || '').length < prec) {
				　　 s[1] = s[1] || '';
				　　s[1] += new Array(prec - s[1].length + 1).join('0');
			　　}
		　　　　return s.join(dec);
			},
			formatFloat(num){
				var re = /([0-9]+\.[0-9]{2})[0-9]*/;
				var newNum = num.toString().replace(re,"$1");
				return newNum;
			},
			showRechargeWindow(){
				this.isShowRechargeWindow=true;
			},
			closeRechargeWindow(val){
				this.isShowRechargeWindow=val;
			},
			successRechargeWindow(){

			}
		},
		data() {
			return {
				UserInfo:[{"UID":"","Nickname":"","QQ":"","BindMobile":"","IconUrl":"","SumBal":0,"PubCount":0,"PubCancel":0,"PubSettleCount":0,"PubConsultCancel":0,"PubSettleHour":0,"AcceptCount":0,"AcceptCancel":0,"AcceptConsultCancel":0,"AcceptSettleCount":0}],
				Data:[{"Pub1":"","Pub2":"","Pub3":"","Pub4":"","Accept1":"","Accept2":"","Accept3":"","Accept4":""}],
				isShow:false,
				isShowRechargeWindow:false
			}
		},
		computed:{
			// 计算属性的 getter
			toMoney: function () {
				return this.number_format(this.UserInfo[0].AvailableBal,2);
			},
			PubCount: function () {
				return this.number_format(this.UserInfo[0].PubCount,0);
			},
			AcceptCount: function () {
				return this.number_format(this.UserInfo[0].AcceptCount,0);
			},
			PubSettleRate: function () {
				if(this.UserInfo[0].PubCount==0)
					return 0;
				else
					return this.formatFloat(this.UserInfo[0].PubSettleCount/this.UserInfo[0].PubCount*100);
			},
			AcceptSettleRate: function () {
				if(this.UserInfo[0].AcceptCount==0)
					return 0;
				else
					return this.formatFloat(this.UserInfo[0].AcceptSettleCount/this.UserInfo[0].AcceptCount*100);
			},
			PubSettleHour: function () {
				if(this.UserInfo[0].PubSettleCount==0)
					return 0;
				else
					return this.UserInfo[0].PubSettleHour/this.UserInfo[0].PubSettleCount;
			},
			PubSettleHour: function () {
				if(this.UserInfo[0].PubSettleCount==0)
					return 0;
				else
					return this.UserInfo[0].PubSettleHour/this.UserInfo[0].PubSettleCount;
			}
		},
		mounted: function () {
			this.GetUserInfo();
			this.GetData();
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/index.vue